import React from 'react';
import { useTranslation } from 'react-i18next';
import FoxAvatar from '../illustrations/FoxAvatar.jsx';
import CashChart from './CashChart.jsx';
import './EmailMock.css';

const LIGHTS = ['red', 'yellow', 'green'];

/**
 * A drawn warning email from Revetall: subject, a traffic light with the status, an optional
 * cash-flow chart, the reasons, a one-line conclusion and a button. Built in HTML so the text
 * wraps nicely.
 * @param {Object} props
 * @param {{subject: string, light: 'red'|'yellow'|'green', status: string, intro: string,
 *   chart?: Object, reasons?: string[], conclusion: string, button: string}} props.email
 *   Texts from `features.<id>.email`; `light` is the lamp that is lit
 * @returns {JSX.Element} Email window
 */
function EmailMock({ email }) {
  const { t } = useTranslation();

  return (
    <div className="email-mock">
      <div className="email-mock-header">
        <div className="email-mock-sender">
          <FoxAvatar className="email-mock-avatar" />
          <div>
            <p className="email-mock-from">{t('chatMock.name')}</p>
            <p className="email-mock-meta">{t('emailMock.to')}</p>
          </div>
          <span className="email-mock-meta email-mock-when">{t('emailMock.when')}</span>
        </div>
        <p className="email-mock-subject">{email.subject}</p>
      </div>

      <div className="email-mock-body">
        <div className="email-mock-status">
          <span className="email-mock-light" aria-hidden="true">
            {LIGHTS.map((light) => (
              <span
                key={light}
                className={`email-mock-lamp is-${light}${light === email.light ? ' is-on' : ''}`}
              />
            ))}
          </span>
          <span className="email-mock-status-text">{email.status}</span>
        </div>
        <p className="email-mock-text">{email.intro}</p>
        {email.chart && <CashChart chart={email.chart} />}
        {email.reasons?.length > 0 && (
          <ul className="email-mock-reasons">
            {email.reasons.map((reason) => (
              <li key={reason}>{reason}</li>
            ))}
          </ul>
        )}
        <p className="email-mock-conclusion">{email.conclusion}</p>
        <span className="email-mock-button" aria-hidden="true">
          {email.button}
        </span>
      </div>
    </div>
  );
}

export default EmailMock;
